import { default as indexOsp7ANAZynMeta } from "E:/workspace/roncoo/roncoo-web/pages/about/index.vue?macro=true";
import { default as certificate37SZEIheaoMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/certificate.vue?macro=true";
import { default as collectu6fo4xmMdBMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/collect.vue?macro=true";
import { default as couponBMGTU756w3Meta } from "E:/workspace/roncoo/roncoo-web/pages/account/coupon.vue?macro=true";
import { default as courseEyeDLWNLnUMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/course.vue?macro=true";
import { default as examUNbACPfxTkMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/exam.vue?macro=true";
import { default as examscoreFhsHmRtOJeMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/examscore.vue?macro=true";
import { default as flowuIcuIFVoM1Meta } from "E:/workspace/roncoo/roncoo-web/pages/account/flow.vue?macro=true";
import { default as generalexammxXpOiWFM7Meta } from "E:/workspace/roncoo/roncoo-web/pages/account/generalexam.vue?macro=true";
import { default as gradeiPMv6rYm1kMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/grade.vue?macro=true";
import { default as homeworkJVgRtff7whMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/homework.vue?macro=true";
import { default as infoKsIwSDfVNNMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/info.vue?macro=true";
import { default as learning_45portraitFvkWZlo6IRMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/learning-portrait.vue?macro=true";
import { default as learning_45trackbDXsXFrbNDMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/learning-track.vue?macro=true";
import { default as materialgv10CtNMqZMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/material.vue?macro=true";
import { default as indexCWvJRK1VHcMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/message/index.vue?macro=true";
import { default as mockExamlthDuyc74LMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/mockExam.vue?macro=true";
import { default as notepRYqd8olkmMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/note.vue?macro=true";
import { default as indexknKbktD7eCMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/order/index.vue?macro=true";
import { default as paperhQu17gjODtMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/paper.vue?macro=true";
import { default as remedy_45packSOYksdH69iMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/remedy-pack.vue?macro=true";
import { default as daydHdm8YLeI4Meta } from "E:/workspace/roncoo/roncoo-web/pages/account/schedule/day.vue?macro=true";
import { default as indexxHIAiIZTK3Meta } from "E:/workspace/roncoo/roncoo-web/pages/account/schedule/index.vue?macro=true";
import { default as month7WKxUxUcmwMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/schedule/month.vue?macro=true";
import { default as week6mYUwWYEb4Meta } from "E:/workspace/roncoo/roncoo-web/pages/account/schedule/week.vue?macro=true";
import { default as scoreGoB0rCpd8rMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/score.vue?macro=true";
import { default as study_45planXcn4RRIGsMMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/study-plan.vue?macro=true";
import { default as thesisnybMTfiSnRMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/thesis.vue?macro=true";
import { default as voucherWFXnf4tfjPMeta } from "E:/workspace/roncoo/roncoo-web/pages/account/voucher.vue?macro=true";
import { default as aiSayz4Z6d0QjJVMeta } from "E:/workspace/roncoo/roncoo-web/pages/ai/aiSay.vue?macro=true";
import { default as aiTalkdNc4PzqbJBMeta } from "E:/workspace/roncoo/roncoo-web/pages/ai/aiTalk.vue?macro=true";
import { default as indexzv6XdUWHQyMeta } from "E:/workspace/roncoo/roncoo-web/pages/apply/index.vue?macro=true";
import { default as listRbcWwbKC5kMeta } from "E:/workspace/roncoo/roncoo-web/pages/article/list.vue?macro=true";
import { default as newsckdJCn4LhbMeta } from "E:/workspace/roncoo/roncoo-web/pages/article/news.vue?macro=true";
import { default as viewOfX52M8IWuMeta } from "E:/workspace/roncoo/roncoo-web/pages/article/view.vue?macro=true";
import { default as index8WzzeDfiDsMeta } from "E:/workspace/roncoo/roncoo-web/pages/cas/index.vue?macro=true";
import { default as cj_home7LWptOLE4sMeta } from "E:/workspace/roncoo/roncoo-web/pages/cj_home.vue?macro=true";
import { default as SignNameD9ds8WwoXaMeta } from "E:/workspace/roncoo/roncoo-web/pages/contract/SignName.vue?macro=true";
import { default as index6MALhkmUxiMeta } from "E:/workspace/roncoo/roncoo-web/pages/contract/index.vue?macro=true";
import { default as signatureosIX0pyssGMeta } from "E:/workspace/roncoo/roncoo-web/pages/contract/signature.vue?macro=true";
import { default as audio292J9wKdc6Meta } from "E:/workspace/roncoo/roncoo-web/pages/course/audio.vue?macro=true";
import { default as combineCtbbYz7NtdMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/combine.vue?macro=true";
import { default as contractDialogsVuFrUZWEqMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/contractDialog.vue?macro=true";
import { default as graphic4BEJSzldgOMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/graphic.vue?macro=true";
import { default as list2tnKtoq1GPMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/list.vue?macro=true";
import { default as liveDKQ6BKuNpFMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/live.vue?macro=true";
import { default as singleopKDW8gUQgMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/single.vue?macro=true";
import { default as subjectXBJTnu2eyLMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/subject.vue?macro=true";
import { default as subjectChildOKcWiUY14BMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/subjectChild.vue?macro=true";
import { default as catalogWatchAuthaOA4nPLomHMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/catalogWatchAuth.js?macro=true";
import { default as chapterItemzqHi8IT7xEMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/chapterItem.vue?macro=true";
import { default as lockedNeedBuyTipLpmVJ1fyu0Meta } from "E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/lockedNeedBuyTip.js?macro=true";
import { default as periodUserAuthGif8X5K4KcFpJMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/periodUserAuthGif.js?macro=true";
import { default as subject_backupdVsWaz3Eh6Meta } from "E:/workspace/roncoo/roncoo-web/pages/course/subject_backup.vue?macro=true";
import { default as topicDRUN1x3yW6Meta } from "E:/workspace/roncoo/roncoo-web/pages/course/topic.vue?macro=true";
import { default as videoC4ZvCLRN0qMeta } from "E:/workspace/roncoo/roncoo-web/pages/course/video.vue?macro=true";
import { default as indexzCHPSaZTJMMeta } from "E:/workspace/roncoo/roncoo-web/pages/download/index.vue?macro=true";
import { default as EntrancetestHeadripcQNmmDoMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/EntrancetestHead.vue?macro=true";
import { default as GeneratingPathXsxWpie9yhMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/GeneratingPath.vue?macro=true";
import { default as SubmitSuccesshAJAT8q2TfMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/SubmitSuccess.vue?macro=true";
import { default as TestItemqoReg2HItLMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/TestItem.vue?macro=true";
import { default as analysisaUA5vGIIHBMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/analysis.vue?macro=true";
import { default as examZ4y5A4pxFeMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/exam.vue?macro=true";
import { default as indexYBRehwPbIkMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/index.vue?macro=true";
import { default as paper_45listOnNnMfkFQIMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/paper-list.vue?macro=true";
import { default as ExamOverviewCommonYzay25cQMMMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/ExamOverviewCommon.vue?macro=true";
import { default as KnowledgeDiagnosisCommoneNCxNCJRe6Meta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/KnowledgeDiagnosisCommon.vue?macro=true";
import { default as OverallhorizontalCommonVFgNtJ0D1DMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/OverallhorizontalCommon.vue?macro=true";
import { default as QuestionAnalysisCommonZCB7eom5ZoMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/QuestionAnalysisCommon.vue?macro=true";
import { default as SuggestionsCommonaIh8pzFdLtMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/SuggestionsCommon.vue?macro=true";
import { default as reportbJ4TCqVfCRMeta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/report.vue?macro=true";
import { default as submitq2HBrdEk53Meta } from "E:/workspace/roncoo/roncoo-web/pages/entrancetest/submit.vue?macro=true";
import { default as analysis7cn9wTya6sMeta } from "E:/workspace/roncoo/roncoo-web/pages/exam/analysis.vue?macro=true";
import { default as emigratedsu6HpRP3w4Meta } from "E:/workspace/roncoo/roncoo-web/pages/exam/emigrated.vue?macro=true";
import { default as indexEKIk232qKoMeta } from "E:/workspace/roncoo/roncoo-web/pages/exam/index.vue?macro=true";
import { default as listwwHRX86YoXMeta } from "E:/workspace/roncoo/roncoo-web/pages/exam/list.vue?macro=true";
import { default as resultVfqeGll33GMeta } from "E:/workspace/roncoo/roncoo-web/pages/exam/result.vue?macro=true";
import { default as startExamoKvzd0tRQ7Meta } from "E:/workspace/roncoo/roncoo-web/pages/exam/startExam.vue?macro=true";
import { default as homeworkPm1QsURUgTMeta } from "E:/workspace/roncoo/roncoo-web/pages/grade/homework.vue?macro=true";
import { default as listAJNElWSH7SMeta } from "E:/workspace/roncoo/roncoo-web/pages/grade/list.vue?macro=true";
import { default as materialtEscJQvaL1Meta } from "E:/workspace/roncoo/roncoo-web/pages/grade/material.vue?macro=true";
import { default as practiceee1gnwVbbqMeta } from "E:/workspace/roncoo/roncoo-web/pages/grade/practice.vue?macro=true";
import { default as viewd8k2iN0tqKMeta } from "E:/workspace/roncoo/roncoo-web/pages/grade/view.vue?macro=true";
import { default as indexaNQ7R18ryuMeta } from "E:/workspace/roncoo/roncoo-web/pages/guide/index.vue?macro=true";
import { default as indexhaZeXWSn3GMeta } from "E:/workspace/roncoo/roncoo-web/pages/index.vue?macro=true";
import { default as index1LYiWSXdRyeMeta } from "E:/workspace/roncoo/roncoo-web/pages/index1.vue?macro=true";
import { default as index_ahcjQX56IZp6YPMeta } from "E:/workspace/roncoo/roncoo-web/pages/index_ahcj.vue?macro=true";
import { default as index_hnkj2W5j5GPbKzDMeta } from "E:/workspace/roncoo/roncoo-web/pages/index_hnkj2.vue?macro=true";
import { default as index_homeE3WVfNfezjMeta } from "E:/workspace/roncoo/roncoo-web/pages/index_home.vue?macro=true";
import { default as agreement7Vuz96Dau4Meta } from "E:/workspace/roncoo/roncoo-web/pages/login/agreement.vue?macro=true";
import { default as indexxJAlrC8pI9Meta } from "E:/workspace/roncoo/roncoo-web/pages/login/index.vue?macro=true";
import { default as CategoryListH8ULc9jbkLMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/CategoryList.vue?macro=true";
import { default as OnlineExamData4JDFPtvcY4Meta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/OnlineExamData.vue?macro=true";
import { default as examUserInfoRBhXsXkkMRMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/examUserInfo.vue?macro=true";
import { default as examView1okahhU0v0Meta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/examView.vue?macro=true";
import { default as indexeeGSfJiJUOMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/index.vue?macro=true";
import { default as problemItemr2HT2l2EqhMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/problemItem.vue?macro=true";
import { default as resultMbR7nCF5uDMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/result.vue?macro=true";
import { default as signqhoUJwmCaMMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/sign.vue?macro=true";
import { default as startExam0dFc2mBCMyMeta } from "E:/workspace/roncoo/roncoo-web/pages/onlineExam/startExam.vue?macro=true";
import { default as childrenListbk0VRspvSQMeta } from "E:/workspace/roncoo/roncoo-web/pages/paper/childrenList.vue?macro=true";
import { default as emigrated9LBXnPIDxJMeta } from "E:/workspace/roncoo/roncoo-web/pages/paper/emigrated.vue?macro=true";
import { default as indexyAurNVIhdVMeta } from "E:/workspace/roncoo/roncoo-web/pages/paper/index.vue?macro=true";
import { default as list4zMKeIEgDIMeta } from "E:/workspace/roncoo/roncoo-web/pages/paper/list.vue?macro=true";
import { default as viewW1gLYRFBV2Meta } from "E:/workspace/roncoo/roncoo-web/pages/paper/view.vue?macro=true";
import { default as contentN2jev2QGSJMeta } from "E:/workspace/roncoo/roncoo-web/pages/partys/content.vue?macro=true";
import { default as indexeV0WS1joemMeta } from "E:/workspace/roncoo/roncoo-web/pages/partys/index.vue?macro=true";
import { default as buyjaPX6TlZucMeta } from "E:/workspace/roncoo/roncoo-web/pages/pay/buy.vue?macro=true";
import { default as paySuccessQPUdUn2DHvMeta } from "E:/workspace/roncoo/roncoo-web/pages/pay/paySuccess.vue?macro=true";
import { default as analysisc0YOtZdnf6Meta } from "E:/workspace/roncoo/roncoo-web/pages/practice/analysis.vue?macro=true";
import { default as dailypn6AOjS2u2Meta } from "E:/workspace/roncoo/roncoo-web/pages/practice/daily.vue?macro=true";
import { default as dailyProblem9NCNB5NOM1Meta } from "E:/workspace/roncoo/roncoo-web/pages/practice/dailyProblem.vue?macro=true";
import { default as errorpH0uNkDhKpMeta } from "E:/workspace/roncoo/roncoo-web/pages/practice/error.vue?macro=true";
import { default as errorAnalysisaqapHIiB7YMeta } from "E:/workspace/roncoo/roncoo-web/pages/practice/errorAnalysis.vue?macro=true";
import { default as errorProblemsjccXApWIOMeta } from "E:/workspace/roncoo/roncoo-web/pages/practice/errorProblem.vue?macro=true";
import { default as errorResultqlFctGtklOMeta } from "E:/workspace/roncoo/roncoo-web/pages/practice/errorResult.vue?macro=true";
import { default as resultMvIEfkSwL5Meta } from "E:/workspace/roncoo/roncoo-web/pages/practice/result.vue?macro=true";
import { default as startPracticeHuGdzBQeyjMeta } from "E:/workspace/roncoo/roncoo-web/pages/practice/startPractice.vue?macro=true";
import { default as view20znInTZP2Meta } from "E:/workspace/roncoo/roncoo-web/pages/practice/view.vue?macro=true";
import { default as indexgTrHaOOix3Meta } from "E:/workspace/roncoo/roncoo-web/pages/register/index.vue?macro=true";
import { default as indext7ZFNXG5Z4Meta } from "E:/workspace/roncoo/roncoo-web/pages/resetpwd/index.vue?macro=true";
import { default as indexcW2X1dCfnkMeta } from "E:/workspace/roncoo/roncoo-web/pages/search/index.vue?macro=true";
import { default as indexblTPJVItxHMeta } from "E:/workspace/roncoo/roncoo-web/pages/settlement/index.vue?macro=true";
import { default as list5IDc91Yy58Meta } from "E:/workspace/roncoo/roncoo-web/pages/teacher/list.vue?macro=true";
import { default as viewy48elAjkpNMeta } from "E:/workspace/roncoo/roncoo-web/pages/teacher/view.vue?macro=true";
import { default as indexbE5hZNfXwaMeta } from "E:/workspace/roncoo/roncoo-web/pages/vip/index.vue?macro=true";
import { default as success0vsJ8tnXivMeta } from "E:/workspace/roncoo/roncoo-web/pages/wx/success.vue?macro=true";
import { default as wxaMcj8zRa0CMeta } from "E:/workspace/roncoo/roncoo-web/pages/wx/wx.vue?macro=true";
export default [
  {
    name: indexOsp7ANAZynMeta?.name ?? "about",
    path: indexOsp7ANAZynMeta?.path ?? "/about",
    meta: indexOsp7ANAZynMeta || {},
    alias: indexOsp7ANAZynMeta?.alias || [],
    redirect: indexOsp7ANAZynMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: certificate37SZEIheaoMeta?.name ?? "account-certificate",
    path: certificate37SZEIheaoMeta?.path ?? "/account/certificate",
    meta: certificate37SZEIheaoMeta || {},
    alias: certificate37SZEIheaoMeta?.alias || [],
    redirect: certificate37SZEIheaoMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/certificate.vue").then(m => m.default || m)
  },
  {
    name: collectu6fo4xmMdBMeta?.name ?? "account-collect",
    path: collectu6fo4xmMdBMeta?.path ?? "/account/collect",
    meta: collectu6fo4xmMdBMeta || {},
    alias: collectu6fo4xmMdBMeta?.alias || [],
    redirect: collectu6fo4xmMdBMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/collect.vue").then(m => m.default || m)
  },
  {
    name: couponBMGTU756w3Meta?.name ?? "account-coupon",
    path: couponBMGTU756w3Meta?.path ?? "/account/coupon",
    meta: couponBMGTU756w3Meta || {},
    alias: couponBMGTU756w3Meta?.alias || [],
    redirect: couponBMGTU756w3Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/coupon.vue").then(m => m.default || m)
  },
  {
    name: courseEyeDLWNLnUMeta?.name ?? "account-course",
    path: courseEyeDLWNLnUMeta?.path ?? "/account/course",
    meta: courseEyeDLWNLnUMeta || {},
    alias: courseEyeDLWNLnUMeta?.alias || [],
    redirect: courseEyeDLWNLnUMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/course.vue").then(m => m.default || m)
  },
  {
    name: examUNbACPfxTkMeta?.name ?? "account-exam",
    path: examUNbACPfxTkMeta?.path ?? "/account/exam",
    meta: examUNbACPfxTkMeta || {},
    alias: examUNbACPfxTkMeta?.alias || [],
    redirect: examUNbACPfxTkMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/exam.vue").then(m => m.default || m)
  },
  {
    name: examscoreFhsHmRtOJeMeta?.name ?? "account-examscore",
    path: examscoreFhsHmRtOJeMeta?.path ?? "/account/examscore",
    meta: examscoreFhsHmRtOJeMeta || {},
    alias: examscoreFhsHmRtOJeMeta?.alias || [],
    redirect: examscoreFhsHmRtOJeMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/examscore.vue").then(m => m.default || m)
  },
  {
    name: flowuIcuIFVoM1Meta?.name ?? "account-flow",
    path: flowuIcuIFVoM1Meta?.path ?? "/account/flow",
    meta: flowuIcuIFVoM1Meta || {},
    alias: flowuIcuIFVoM1Meta?.alias || [],
    redirect: flowuIcuIFVoM1Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/flow.vue").then(m => m.default || m)
  },
  {
    name: generalexammxXpOiWFM7Meta?.name ?? "account-generalexam",
    path: generalexammxXpOiWFM7Meta?.path ?? "/account/generalexam",
    meta: generalexammxXpOiWFM7Meta || {},
    alias: generalexammxXpOiWFM7Meta?.alias || [],
    redirect: generalexammxXpOiWFM7Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/generalexam.vue").then(m => m.default || m)
  },
  {
    name: gradeiPMv6rYm1kMeta?.name ?? "account-grade",
    path: gradeiPMv6rYm1kMeta?.path ?? "/account/grade",
    meta: gradeiPMv6rYm1kMeta || {},
    alias: gradeiPMv6rYm1kMeta?.alias || [],
    redirect: gradeiPMv6rYm1kMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/grade.vue").then(m => m.default || m)
  },
  {
    name: homeworkJVgRtff7whMeta?.name ?? "account-homework",
    path: homeworkJVgRtff7whMeta?.path ?? "/account/homework",
    meta: homeworkJVgRtff7whMeta || {},
    alias: homeworkJVgRtff7whMeta?.alias || [],
    redirect: homeworkJVgRtff7whMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/homework.vue").then(m => m.default || m)
  },
  {
    name: infoKsIwSDfVNNMeta?.name ?? "account-info",
    path: infoKsIwSDfVNNMeta?.path ?? "/account/info",
    meta: infoKsIwSDfVNNMeta || {},
    alias: infoKsIwSDfVNNMeta?.alias || [],
    redirect: infoKsIwSDfVNNMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/info.vue").then(m => m.default || m)
  },
  {
    name: learning_45portraitFvkWZlo6IRMeta?.name ?? "account-learning-portrait",
    path: learning_45portraitFvkWZlo6IRMeta?.path ?? "/account/learning-portrait",
    meta: learning_45portraitFvkWZlo6IRMeta || {},
    alias: learning_45portraitFvkWZlo6IRMeta?.alias || [],
    redirect: learning_45portraitFvkWZlo6IRMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/learning-portrait.vue").then(m => m.default || m)
  },
  {
    name: learning_45trackbDXsXFrbNDMeta?.name ?? "account-learning-track",
    path: learning_45trackbDXsXFrbNDMeta?.path ?? "/account/learning-track",
    meta: learning_45trackbDXsXFrbNDMeta || {},
    alias: learning_45trackbDXsXFrbNDMeta?.alias || [],
    redirect: learning_45trackbDXsXFrbNDMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/learning-track.vue").then(m => m.default || m)
  },
  {
    name: materialgv10CtNMqZMeta?.name ?? "account-material",
    path: materialgv10CtNMqZMeta?.path ?? "/account/material",
    meta: materialgv10CtNMqZMeta || {},
    alias: materialgv10CtNMqZMeta?.alias || [],
    redirect: materialgv10CtNMqZMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/material.vue").then(m => m.default || m)
  },
  {
    name: indexCWvJRK1VHcMeta?.name ?? "account-message",
    path: indexCWvJRK1VHcMeta?.path ?? "/account/message",
    meta: indexCWvJRK1VHcMeta || {},
    alias: indexCWvJRK1VHcMeta?.alias || [],
    redirect: indexCWvJRK1VHcMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/message/index.vue").then(m => m.default || m)
  },
  {
    name: mockExamlthDuyc74LMeta?.name ?? "account-mockExam",
    path: mockExamlthDuyc74LMeta?.path ?? "/account/mockExam",
    meta: mockExamlthDuyc74LMeta || {},
    alias: mockExamlthDuyc74LMeta?.alias || [],
    redirect: mockExamlthDuyc74LMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/mockExam.vue").then(m => m.default || m)
  },
  {
    name: notepRYqd8olkmMeta?.name ?? "account-note",
    path: notepRYqd8olkmMeta?.path ?? "/account/note",
    meta: notepRYqd8olkmMeta || {},
    alias: notepRYqd8olkmMeta?.alias || [],
    redirect: notepRYqd8olkmMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/note.vue").then(m => m.default || m)
  },
  {
    name: indexknKbktD7eCMeta?.name ?? "account-order",
    path: indexknKbktD7eCMeta?.path ?? "/account/order",
    meta: indexknKbktD7eCMeta || {},
    alias: indexknKbktD7eCMeta?.alias || [],
    redirect: indexknKbktD7eCMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/order/index.vue").then(m => m.default || m)
  },
  {
    name: paperhQu17gjODtMeta?.name ?? "account-paper",
    path: paperhQu17gjODtMeta?.path ?? "/account/paper",
    meta: paperhQu17gjODtMeta || {},
    alias: paperhQu17gjODtMeta?.alias || [],
    redirect: paperhQu17gjODtMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/paper.vue").then(m => m.default || m)
  },
  {
    name: remedy_45packSOYksdH69iMeta?.name ?? "account-remedy-pack",
    path: remedy_45packSOYksdH69iMeta?.path ?? "/account/remedy-pack",
    meta: remedy_45packSOYksdH69iMeta || {},
    alias: remedy_45packSOYksdH69iMeta?.alias || [],
    redirect: remedy_45packSOYksdH69iMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/remedy-pack.vue").then(m => m.default || m)
  },
  {
    name: daydHdm8YLeI4Meta?.name ?? "account-schedule-day",
    path: daydHdm8YLeI4Meta?.path ?? "/account/schedule/day",
    meta: daydHdm8YLeI4Meta || {},
    alias: daydHdm8YLeI4Meta?.alias || [],
    redirect: daydHdm8YLeI4Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/schedule/day.vue").then(m => m.default || m)
  },
  {
    name: indexxHIAiIZTK3Meta?.name ?? "account-schedule",
    path: indexxHIAiIZTK3Meta?.path ?? "/account/schedule",
    meta: indexxHIAiIZTK3Meta || {},
    alias: indexxHIAiIZTK3Meta?.alias || [],
    redirect: indexxHIAiIZTK3Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/schedule/index.vue").then(m => m.default || m)
  },
  {
    name: month7WKxUxUcmwMeta?.name ?? "account-schedule-month",
    path: month7WKxUxUcmwMeta?.path ?? "/account/schedule/month",
    meta: month7WKxUxUcmwMeta || {},
    alias: month7WKxUxUcmwMeta?.alias || [],
    redirect: month7WKxUxUcmwMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/schedule/month.vue").then(m => m.default || m)
  },
  {
    name: week6mYUwWYEb4Meta?.name ?? "account-schedule-week",
    path: week6mYUwWYEb4Meta?.path ?? "/account/schedule/week",
    meta: week6mYUwWYEb4Meta || {},
    alias: week6mYUwWYEb4Meta?.alias || [],
    redirect: week6mYUwWYEb4Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/schedule/week.vue").then(m => m.default || m)
  },
  {
    name: scoreGoB0rCpd8rMeta?.name ?? "account-score",
    path: scoreGoB0rCpd8rMeta?.path ?? "/account/score",
    meta: scoreGoB0rCpd8rMeta || {},
    alias: scoreGoB0rCpd8rMeta?.alias || [],
    redirect: scoreGoB0rCpd8rMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/score.vue").then(m => m.default || m)
  },
  {
    name: study_45planXcn4RRIGsMMeta?.name ?? "account-study-plan",
    path: study_45planXcn4RRIGsMMeta?.path ?? "/account/study-plan",
    meta: study_45planXcn4RRIGsMMeta || {},
    alias: study_45planXcn4RRIGsMMeta?.alias || [],
    redirect: study_45planXcn4RRIGsMMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/study-plan.vue").then(m => m.default || m)
  },
  {
    name: thesisnybMTfiSnRMeta?.name ?? "account-thesis",
    path: thesisnybMTfiSnRMeta?.path ?? "/account/thesis",
    meta: thesisnybMTfiSnRMeta || {},
    alias: thesisnybMTfiSnRMeta?.alias || [],
    redirect: thesisnybMTfiSnRMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/thesis.vue").then(m => m.default || m)
  },
  {
    name: voucherWFXnf4tfjPMeta?.name ?? "account-voucher",
    path: voucherWFXnf4tfjPMeta?.path ?? "/account/voucher",
    meta: voucherWFXnf4tfjPMeta || {},
    alias: voucherWFXnf4tfjPMeta?.alias || [],
    redirect: voucherWFXnf4tfjPMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/account/voucher.vue").then(m => m.default || m)
  },
  {
    name: aiSayz4Z6d0QjJVMeta?.name ?? "ai-aiSay",
    path: aiSayz4Z6d0QjJVMeta?.path ?? "/ai/aiSay",
    meta: aiSayz4Z6d0QjJVMeta || {},
    alias: aiSayz4Z6d0QjJVMeta?.alias || [],
    redirect: aiSayz4Z6d0QjJVMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/ai/aiSay.vue").then(m => m.default || m)
  },
  {
    name: aiTalkdNc4PzqbJBMeta?.name ?? "ai-aiTalk",
    path: aiTalkdNc4PzqbJBMeta?.path ?? "/ai/aiTalk",
    meta: aiTalkdNc4PzqbJBMeta || {},
    alias: aiTalkdNc4PzqbJBMeta?.alias || [],
    redirect: aiTalkdNc4PzqbJBMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/ai/aiTalk.vue").then(m => m.default || m)
  },
  {
    name: indexzv6XdUWHQyMeta?.name ?? "apply",
    path: indexzv6XdUWHQyMeta?.path ?? "/apply",
    meta: indexzv6XdUWHQyMeta || {},
    alias: indexzv6XdUWHQyMeta?.alias || [],
    redirect: indexzv6XdUWHQyMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/apply/index.vue").then(m => m.default || m)
  },
  {
    name: listRbcWwbKC5kMeta?.name ?? "article-list",
    path: listRbcWwbKC5kMeta?.path ?? "/article/list",
    meta: listRbcWwbKC5kMeta || {},
    alias: listRbcWwbKC5kMeta?.alias || [],
    redirect: listRbcWwbKC5kMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/article/list.vue").then(m => m.default || m)
  },
  {
    name: newsckdJCn4LhbMeta?.name ?? "article-news",
    path: newsckdJCn4LhbMeta?.path ?? "/article/news",
    meta: newsckdJCn4LhbMeta || {},
    alias: newsckdJCn4LhbMeta?.alias || [],
    redirect: newsckdJCn4LhbMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/article/news.vue").then(m => m.default || m)
  },
  {
    name: viewOfX52M8IWuMeta?.name ?? "article-view",
    path: viewOfX52M8IWuMeta?.path ?? "/article/view",
    meta: viewOfX52M8IWuMeta || {},
    alias: viewOfX52M8IWuMeta?.alias || [],
    redirect: viewOfX52M8IWuMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/article/view.vue").then(m => m.default || m)
  },
  {
    name: index8WzzeDfiDsMeta?.name ?? "cas",
    path: index8WzzeDfiDsMeta?.path ?? "/cas",
    meta: index8WzzeDfiDsMeta || {},
    alias: index8WzzeDfiDsMeta?.alias || [],
    redirect: index8WzzeDfiDsMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/cas/index.vue").then(m => m.default || m)
  },
  {
    name: cj_home7LWptOLE4sMeta?.name ?? "cj_home",
    path: cj_home7LWptOLE4sMeta?.path ?? "/cj_home",
    meta: cj_home7LWptOLE4sMeta || {},
    alias: cj_home7LWptOLE4sMeta?.alias || [],
    redirect: cj_home7LWptOLE4sMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/cj_home.vue").then(m => m.default || m)
  },
  {
    name: SignNameD9ds8WwoXaMeta?.name ?? "contract-SignName",
    path: SignNameD9ds8WwoXaMeta?.path ?? "/contract/SignName",
    meta: SignNameD9ds8WwoXaMeta || {},
    alias: SignNameD9ds8WwoXaMeta?.alias || [],
    redirect: SignNameD9ds8WwoXaMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/contract/SignName.vue").then(m => m.default || m)
  },
  {
    name: index6MALhkmUxiMeta?.name ?? "contract",
    path: index6MALhkmUxiMeta?.path ?? "/contract",
    meta: index6MALhkmUxiMeta || {},
    alias: index6MALhkmUxiMeta?.alias || [],
    redirect: index6MALhkmUxiMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/contract/index.vue").then(m => m.default || m)
  },
  {
    name: signatureosIX0pyssGMeta?.name ?? "contract-signature",
    path: signatureosIX0pyssGMeta?.path ?? "/contract/signature",
    meta: signatureosIX0pyssGMeta || {},
    alias: signatureosIX0pyssGMeta?.alias || [],
    redirect: signatureosIX0pyssGMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/contract/signature.vue").then(m => m.default || m)
  },
  {
    name: audio292J9wKdc6Meta?.name ?? "course-audio",
    path: audio292J9wKdc6Meta?.path ?? "/course/audio",
    meta: audio292J9wKdc6Meta || {},
    alias: audio292J9wKdc6Meta?.alias || [],
    redirect: audio292J9wKdc6Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/audio.vue").then(m => m.default || m)
  },
  {
    name: combineCtbbYz7NtdMeta?.name ?? "course-combine",
    path: combineCtbbYz7NtdMeta?.path ?? "/course/combine",
    meta: combineCtbbYz7NtdMeta || {},
    alias: combineCtbbYz7NtdMeta?.alias || [],
    redirect: combineCtbbYz7NtdMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/combine.vue").then(m => m.default || m)
  },
  {
    name: contractDialogsVuFrUZWEqMeta?.name ?? "course-contractDialog",
    path: contractDialogsVuFrUZWEqMeta?.path ?? "/course/contractDialog",
    meta: contractDialogsVuFrUZWEqMeta || {},
    alias: contractDialogsVuFrUZWEqMeta?.alias || [],
    redirect: contractDialogsVuFrUZWEqMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/contractDialog.vue").then(m => m.default || m)
  },
  {
    name: graphic4BEJSzldgOMeta?.name ?? "course-graphic",
    path: graphic4BEJSzldgOMeta?.path ?? "/course/graphic",
    meta: graphic4BEJSzldgOMeta || {},
    alias: graphic4BEJSzldgOMeta?.alias || [],
    redirect: graphic4BEJSzldgOMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/graphic.vue").then(m => m.default || m)
  },
  {
    name: list2tnKtoq1GPMeta?.name ?? "course-list",
    path: list2tnKtoq1GPMeta?.path ?? "/course/list",
    meta: list2tnKtoq1GPMeta || {},
    alias: list2tnKtoq1GPMeta?.alias || [],
    redirect: list2tnKtoq1GPMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/list.vue").then(m => m.default || m)
  },
  {
    name: liveDKQ6BKuNpFMeta?.name ?? "course-live",
    path: liveDKQ6BKuNpFMeta?.path ?? "/course/live",
    meta: liveDKQ6BKuNpFMeta || {},
    alias: liveDKQ6BKuNpFMeta?.alias || [],
    redirect: liveDKQ6BKuNpFMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/live.vue").then(m => m.default || m)
  },
  {
    name: singleopKDW8gUQgMeta?.name ?? "course-single",
    path: singleopKDW8gUQgMeta?.path ?? "/course/single",
    meta: singleopKDW8gUQgMeta || {},
    alias: singleopKDW8gUQgMeta?.alias || [],
    redirect: singleopKDW8gUQgMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/single.vue").then(m => m.default || m)
  },
  {
    name: subjectXBJTnu2eyLMeta?.name ?? "course-subject",
    path: subjectXBJTnu2eyLMeta?.path ?? "/course/subject",
    meta: subjectXBJTnu2eyLMeta || {},
    alias: subjectXBJTnu2eyLMeta?.alias || [],
    redirect: subjectXBJTnu2eyLMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subject.vue").then(m => m.default || m)
  },
  {
    name: subjectChildOKcWiUY14BMeta?.name ?? "course-subjectChild",
    path: subjectChildOKcWiUY14BMeta?.path ?? "/course/subjectChild",
    meta: subjectChildOKcWiUY14BMeta || {},
    alias: subjectChildOKcWiUY14BMeta?.alias || [],
    redirect: subjectChildOKcWiUY14BMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subjectChild.vue").then(m => m.default || m)
  },
  {
    name: catalogWatchAuthaOA4nPLomHMeta?.name ?? "course-subjectComponent-catalogWatchAuth",
    path: catalogWatchAuthaOA4nPLomHMeta?.path ?? "/course/subjectComponent/catalogWatchAuth",
    meta: catalogWatchAuthaOA4nPLomHMeta || {},
    alias: catalogWatchAuthaOA4nPLomHMeta?.alias || [],
    redirect: catalogWatchAuthaOA4nPLomHMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/catalogWatchAuth.js").then(m => m.default || m)
  },
  {
    name: chapterItemzqHi8IT7xEMeta?.name ?? "course-subjectComponent-chapterItem",
    path: chapterItemzqHi8IT7xEMeta?.path ?? "/course/subjectComponent/chapterItem",
    meta: chapterItemzqHi8IT7xEMeta || {},
    alias: chapterItemzqHi8IT7xEMeta?.alias || [],
    redirect: chapterItemzqHi8IT7xEMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/chapterItem.vue").then(m => m.default || m)
  },
  {
    name: lockedNeedBuyTipLpmVJ1fyu0Meta?.name ?? "course-subjectComponent-lockedNeedBuyTip",
    path: lockedNeedBuyTipLpmVJ1fyu0Meta?.path ?? "/course/subjectComponent/lockedNeedBuyTip",
    meta: lockedNeedBuyTipLpmVJ1fyu0Meta || {},
    alias: lockedNeedBuyTipLpmVJ1fyu0Meta?.alias || [],
    redirect: lockedNeedBuyTipLpmVJ1fyu0Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/lockedNeedBuyTip.js").then(m => m.default || m)
  },
  {
    name: periodUserAuthGif8X5K4KcFpJMeta?.name ?? "course-subjectComponent-periodUserAuthGif",
    path: periodUserAuthGif8X5K4KcFpJMeta?.path ?? "/course/subjectComponent/periodUserAuthGif",
    meta: periodUserAuthGif8X5K4KcFpJMeta || {},
    alias: periodUserAuthGif8X5K4KcFpJMeta?.alias || [],
    redirect: periodUserAuthGif8X5K4KcFpJMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subjectComponent/periodUserAuthGif.js").then(m => m.default || m)
  },
  {
    name: subject_backupdVsWaz3Eh6Meta?.name ?? "course-subject_backup",
    path: subject_backupdVsWaz3Eh6Meta?.path ?? "/course/subject_backup",
    meta: subject_backupdVsWaz3Eh6Meta || {},
    alias: subject_backupdVsWaz3Eh6Meta?.alias || [],
    redirect: subject_backupdVsWaz3Eh6Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/subject_backup.vue").then(m => m.default || m)
  },
  {
    name: topicDRUN1x3yW6Meta?.name ?? "course-topic",
    path: topicDRUN1x3yW6Meta?.path ?? "/course/topic",
    meta: topicDRUN1x3yW6Meta || {},
    alias: topicDRUN1x3yW6Meta?.alias || [],
    redirect: topicDRUN1x3yW6Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/topic.vue").then(m => m.default || m)
  },
  {
    name: videoC4ZvCLRN0qMeta?.name ?? "course-video",
    path: videoC4ZvCLRN0qMeta?.path ?? "/course/video",
    meta: videoC4ZvCLRN0qMeta || {},
    alias: videoC4ZvCLRN0qMeta?.alias || [],
    redirect: videoC4ZvCLRN0qMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/course/video.vue").then(m => m.default || m)
  },
  {
    name: indexzCHPSaZTJMMeta?.name ?? "download",
    path: indexzCHPSaZTJMMeta?.path ?? "/download",
    meta: indexzCHPSaZTJMMeta || {},
    alias: indexzCHPSaZTJMMeta?.alias || [],
    redirect: indexzCHPSaZTJMMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: EntrancetestHeadripcQNmmDoMeta?.name ?? "entrancetest-EntrancetestHead",
    path: EntrancetestHeadripcQNmmDoMeta?.path ?? "/entrancetest/EntrancetestHead",
    meta: EntrancetestHeadripcQNmmDoMeta || {},
    alias: EntrancetestHeadripcQNmmDoMeta?.alias || [],
    redirect: EntrancetestHeadripcQNmmDoMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/EntrancetestHead.vue").then(m => m.default || m)
  },
  {
    name: GeneratingPathXsxWpie9yhMeta?.name ?? "entrancetest-GeneratingPath",
    path: GeneratingPathXsxWpie9yhMeta?.path ?? "/entrancetest/GeneratingPath",
    meta: GeneratingPathXsxWpie9yhMeta || {},
    alias: GeneratingPathXsxWpie9yhMeta?.alias || [],
    redirect: GeneratingPathXsxWpie9yhMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/GeneratingPath.vue").then(m => m.default || m)
  },
  {
    name: SubmitSuccesshAJAT8q2TfMeta?.name ?? "entrancetest-SubmitSuccess",
    path: SubmitSuccesshAJAT8q2TfMeta?.path ?? "/entrancetest/SubmitSuccess",
    meta: SubmitSuccesshAJAT8q2TfMeta || {},
    alias: SubmitSuccesshAJAT8q2TfMeta?.alias || [],
    redirect: SubmitSuccesshAJAT8q2TfMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/SubmitSuccess.vue").then(m => m.default || m)
  },
  {
    name: TestItemqoReg2HItLMeta?.name ?? "entrancetest-TestItem",
    path: TestItemqoReg2HItLMeta?.path ?? "/entrancetest/TestItem",
    meta: TestItemqoReg2HItLMeta || {},
    alias: TestItemqoReg2HItLMeta?.alias || [],
    redirect: TestItemqoReg2HItLMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/TestItem.vue").then(m => m.default || m)
  },
  {
    name: analysisaUA5vGIIHBMeta?.name ?? "entrancetest-analysis",
    path: analysisaUA5vGIIHBMeta?.path ?? "/entrancetest/analysis",
    meta: analysisaUA5vGIIHBMeta || {},
    alias: analysisaUA5vGIIHBMeta?.alias || [],
    redirect: analysisaUA5vGIIHBMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/analysis.vue").then(m => m.default || m)
  },
  {
    name: examZ4y5A4pxFeMeta?.name ?? "entrancetest-exam",
    path: examZ4y5A4pxFeMeta?.path ?? "/entrancetest/exam",
    meta: examZ4y5A4pxFeMeta || {},
    alias: examZ4y5A4pxFeMeta?.alias || [],
    redirect: examZ4y5A4pxFeMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/exam.vue").then(m => m.default || m)
  },
  {
    name: indexYBRehwPbIkMeta?.name ?? "entrancetest",
    path: indexYBRehwPbIkMeta?.path ?? "/entrancetest",
    meta: indexYBRehwPbIkMeta || {},
    alias: indexYBRehwPbIkMeta?.alias || [],
    redirect: indexYBRehwPbIkMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/index.vue").then(m => m.default || m)
  },
  {
    name: paper_45listOnNnMfkFQIMeta?.name ?? "entrancetest-paper-list",
    path: paper_45listOnNnMfkFQIMeta?.path ?? "/entrancetest/paper-list",
    meta: paper_45listOnNnMfkFQIMeta || {},
    alias: paper_45listOnNnMfkFQIMeta?.alias || [],
    redirect: paper_45listOnNnMfkFQIMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/paper-list.vue").then(m => m.default || m)
  },
  {
    name: ExamOverviewCommonYzay25cQMMMeta?.name ?? "entrancetest-report-modules-ExamOverviewCommon",
    path: ExamOverviewCommonYzay25cQMMMeta?.path ?? "/entrancetest/report-modules/ExamOverviewCommon",
    meta: ExamOverviewCommonYzay25cQMMMeta || {},
    alias: ExamOverviewCommonYzay25cQMMMeta?.alias || [],
    redirect: ExamOverviewCommonYzay25cQMMMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/ExamOverviewCommon.vue").then(m => m.default || m)
  },
  {
    name: KnowledgeDiagnosisCommoneNCxNCJRe6Meta?.name ?? "entrancetest-report-modules-KnowledgeDiagnosisCommon",
    path: KnowledgeDiagnosisCommoneNCxNCJRe6Meta?.path ?? "/entrancetest/report-modules/KnowledgeDiagnosisCommon",
    meta: KnowledgeDiagnosisCommoneNCxNCJRe6Meta || {},
    alias: KnowledgeDiagnosisCommoneNCxNCJRe6Meta?.alias || [],
    redirect: KnowledgeDiagnosisCommoneNCxNCJRe6Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/KnowledgeDiagnosisCommon.vue").then(m => m.default || m)
  },
  {
    name: OverallhorizontalCommonVFgNtJ0D1DMeta?.name ?? "entrancetest-report-modules-OverallhorizontalCommon",
    path: OverallhorizontalCommonVFgNtJ0D1DMeta?.path ?? "/entrancetest/report-modules/OverallhorizontalCommon",
    meta: OverallhorizontalCommonVFgNtJ0D1DMeta || {},
    alias: OverallhorizontalCommonVFgNtJ0D1DMeta?.alias || [],
    redirect: OverallhorizontalCommonVFgNtJ0D1DMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/OverallhorizontalCommon.vue").then(m => m.default || m)
  },
  {
    name: QuestionAnalysisCommonZCB7eom5ZoMeta?.name ?? "entrancetest-report-modules-QuestionAnalysisCommon",
    path: QuestionAnalysisCommonZCB7eom5ZoMeta?.path ?? "/entrancetest/report-modules/QuestionAnalysisCommon",
    meta: QuestionAnalysisCommonZCB7eom5ZoMeta || {},
    alias: QuestionAnalysisCommonZCB7eom5ZoMeta?.alias || [],
    redirect: QuestionAnalysisCommonZCB7eom5ZoMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/QuestionAnalysisCommon.vue").then(m => m.default || m)
  },
  {
    name: SuggestionsCommonaIh8pzFdLtMeta?.name ?? "entrancetest-report-modules-SuggestionsCommon",
    path: SuggestionsCommonaIh8pzFdLtMeta?.path ?? "/entrancetest/report-modules/SuggestionsCommon",
    meta: SuggestionsCommonaIh8pzFdLtMeta || {},
    alias: SuggestionsCommonaIh8pzFdLtMeta?.alias || [],
    redirect: SuggestionsCommonaIh8pzFdLtMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/report-modules/SuggestionsCommon.vue").then(m => m.default || m)
  },
  {
    name: reportbJ4TCqVfCRMeta?.name ?? "entrancetest-report",
    path: reportbJ4TCqVfCRMeta?.path ?? "/entrancetest/report",
    meta: reportbJ4TCqVfCRMeta || {},
    alias: reportbJ4TCqVfCRMeta?.alias || [],
    redirect: reportbJ4TCqVfCRMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/report.vue").then(m => m.default || m)
  },
  {
    name: submitq2HBrdEk53Meta?.name ?? "entrancetest-submit",
    path: submitq2HBrdEk53Meta?.path ?? "/entrancetest/submit",
    meta: submitq2HBrdEk53Meta || {},
    alias: submitq2HBrdEk53Meta?.alias || [],
    redirect: submitq2HBrdEk53Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/entrancetest/submit.vue").then(m => m.default || m)
  },
  {
    name: analysis7cn9wTya6sMeta?.name ?? "exam-analysis",
    path: analysis7cn9wTya6sMeta?.path ?? "/exam/analysis",
    meta: analysis7cn9wTya6sMeta || {},
    alias: analysis7cn9wTya6sMeta?.alias || [],
    redirect: analysis7cn9wTya6sMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/exam/analysis.vue").then(m => m.default || m)
  },
  {
    name: emigratedsu6HpRP3w4Meta?.name ?? "exam-emigrated",
    path: emigratedsu6HpRP3w4Meta?.path ?? "/exam/emigrated",
    meta: emigratedsu6HpRP3w4Meta || {},
    alias: emigratedsu6HpRP3w4Meta?.alias || [],
    redirect: emigratedsu6HpRP3w4Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/exam/emigrated.vue").then(m => m.default || m)
  },
  {
    name: indexEKIk232qKoMeta?.name ?? "exam",
    path: indexEKIk232qKoMeta?.path ?? "/exam",
    meta: indexEKIk232qKoMeta || {},
    alias: indexEKIk232qKoMeta?.alias || [],
    redirect: indexEKIk232qKoMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/exam/index.vue").then(m => m.default || m)
  },
  {
    name: listwwHRX86YoXMeta?.name ?? "exam-list",
    path: listwwHRX86YoXMeta?.path ?? "/exam/list",
    meta: listwwHRX86YoXMeta || {},
    alias: listwwHRX86YoXMeta?.alias || [],
    redirect: listwwHRX86YoXMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/exam/list.vue").then(m => m.default || m)
  },
  {
    name: resultVfqeGll33GMeta?.name ?? "exam-result",
    path: resultVfqeGll33GMeta?.path ?? "/exam/result",
    meta: resultVfqeGll33GMeta || {},
    alias: resultVfqeGll33GMeta?.alias || [],
    redirect: resultVfqeGll33GMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/exam/result.vue").then(m => m.default || m)
  },
  {
    name: startExamoKvzd0tRQ7Meta?.name ?? "exam-startExam",
    path: startExamoKvzd0tRQ7Meta?.path ?? "/exam/startExam",
    meta: startExamoKvzd0tRQ7Meta || {},
    alias: startExamoKvzd0tRQ7Meta?.alias || [],
    redirect: startExamoKvzd0tRQ7Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/exam/startExam.vue").then(m => m.default || m)
  },
  {
    name: homeworkPm1QsURUgTMeta?.name ?? "grade-homework",
    path: homeworkPm1QsURUgTMeta?.path ?? "/grade/homework",
    meta: homeworkPm1QsURUgTMeta || {},
    alias: homeworkPm1QsURUgTMeta?.alias || [],
    redirect: homeworkPm1QsURUgTMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/grade/homework.vue").then(m => m.default || m)
  },
  {
    name: listAJNElWSH7SMeta?.name ?? "grade-list",
    path: listAJNElWSH7SMeta?.path ?? "/grade/list",
    meta: listAJNElWSH7SMeta || {},
    alias: listAJNElWSH7SMeta?.alias || [],
    redirect: listAJNElWSH7SMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/grade/list.vue").then(m => m.default || m)
  },
  {
    name: materialtEscJQvaL1Meta?.name ?? "grade-material",
    path: materialtEscJQvaL1Meta?.path ?? "/grade/material",
    meta: materialtEscJQvaL1Meta || {},
    alias: materialtEscJQvaL1Meta?.alias || [],
    redirect: materialtEscJQvaL1Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/grade/material.vue").then(m => m.default || m)
  },
  {
    name: practiceee1gnwVbbqMeta?.name ?? "grade-practice",
    path: practiceee1gnwVbbqMeta?.path ?? "/grade/practice",
    meta: practiceee1gnwVbbqMeta || {},
    alias: practiceee1gnwVbbqMeta?.alias || [],
    redirect: practiceee1gnwVbbqMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/grade/practice.vue").then(m => m.default || m)
  },
  {
    name: viewd8k2iN0tqKMeta?.name ?? "grade-view",
    path: viewd8k2iN0tqKMeta?.path ?? "/grade/view",
    meta: viewd8k2iN0tqKMeta || {},
    alias: viewd8k2iN0tqKMeta?.alias || [],
    redirect: viewd8k2iN0tqKMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/grade/view.vue").then(m => m.default || m)
  },
  {
    name: indexaNQ7R18ryuMeta?.name ?? "guide",
    path: indexaNQ7R18ryuMeta?.path ?? "/guide",
    meta: indexaNQ7R18ryuMeta || {},
    alias: indexaNQ7R18ryuMeta?.alias || [],
    redirect: indexaNQ7R18ryuMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: indexhaZeXWSn3GMeta?.name ?? "index",
    path: indexhaZeXWSn3GMeta?.path ?? "/",
    meta: indexhaZeXWSn3GMeta || {},
    alias: indexhaZeXWSn3GMeta?.alias || [],
    redirect: indexhaZeXWSn3GMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1LYiWSXdRyeMeta?.name ?? "index1",
    path: index1LYiWSXdRyeMeta?.path ?? "/index1",
    meta: index1LYiWSXdRyeMeta || {},
    alias: index1LYiWSXdRyeMeta?.alias || [],
    redirect: index1LYiWSXdRyeMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/index1.vue").then(m => m.default || m)
  },
  {
    name: index_ahcjQX56IZp6YPMeta?.name ?? "index_ahcj",
    path: index_ahcjQX56IZp6YPMeta?.path ?? "/index_ahcj",
    meta: index_ahcjQX56IZp6YPMeta || {},
    alias: index_ahcjQX56IZp6YPMeta?.alias || [],
    redirect: index_ahcjQX56IZp6YPMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/index_ahcj.vue").then(m => m.default || m)
  },
  {
    name: index_hnkj2W5j5GPbKzDMeta?.name ?? "index_hnkj2",
    path: index_hnkj2W5j5GPbKzDMeta?.path ?? "/index_hnkj2",
    meta: index_hnkj2W5j5GPbKzDMeta || {},
    alias: index_hnkj2W5j5GPbKzDMeta?.alias || [],
    redirect: index_hnkj2W5j5GPbKzDMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/index_hnkj2.vue").then(m => m.default || m)
  },
  {
    name: index_homeE3WVfNfezjMeta?.name ?? "index_home",
    path: index_homeE3WVfNfezjMeta?.path ?? "/index_home",
    meta: index_homeE3WVfNfezjMeta || {},
    alias: index_homeE3WVfNfezjMeta?.alias || [],
    redirect: index_homeE3WVfNfezjMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/index_home.vue").then(m => m.default || m)
  },
  {
    name: agreement7Vuz96Dau4Meta?.name ?? "login-agreement",
    path: agreement7Vuz96Dau4Meta?.path ?? "/login/agreement",
    meta: agreement7Vuz96Dau4Meta || {},
    alias: agreement7Vuz96Dau4Meta?.alias || [],
    redirect: agreement7Vuz96Dau4Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/login/agreement.vue").then(m => m.default || m)
  },
  {
    name: indexxJAlrC8pI9Meta?.name ?? "login",
    path: indexxJAlrC8pI9Meta?.path ?? "/login",
    meta: indexxJAlrC8pI9Meta || {},
    alias: indexxJAlrC8pI9Meta?.alias || [],
    redirect: indexxJAlrC8pI9Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: CategoryListH8ULc9jbkLMeta?.name ?? "onlineExam-CategoryList",
    path: CategoryListH8ULc9jbkLMeta?.path ?? "/onlineExam/CategoryList",
    meta: CategoryListH8ULc9jbkLMeta || {},
    alias: CategoryListH8ULc9jbkLMeta?.alias || [],
    redirect: CategoryListH8ULc9jbkLMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/CategoryList.vue").then(m => m.default || m)
  },
  {
    name: OnlineExamData4JDFPtvcY4Meta?.name ?? "onlineExam-OnlineExamData",
    path: OnlineExamData4JDFPtvcY4Meta?.path ?? "/onlineExam/OnlineExamData",
    meta: OnlineExamData4JDFPtvcY4Meta || {},
    alias: OnlineExamData4JDFPtvcY4Meta?.alias || [],
    redirect: OnlineExamData4JDFPtvcY4Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/OnlineExamData.vue").then(m => m.default || m)
  },
  {
    name: examUserInfoRBhXsXkkMRMeta?.name ?? "onlineExam-examUserInfo",
    path: examUserInfoRBhXsXkkMRMeta?.path ?? "/onlineExam/examUserInfo",
    meta: examUserInfoRBhXsXkkMRMeta || {},
    alias: examUserInfoRBhXsXkkMRMeta?.alias || [],
    redirect: examUserInfoRBhXsXkkMRMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/examUserInfo.vue").then(m => m.default || m)
  },
  {
    name: examView1okahhU0v0Meta?.name ?? "onlineExam-examView",
    path: examView1okahhU0v0Meta?.path ?? "/onlineExam/examView",
    meta: examView1okahhU0v0Meta || {},
    alias: examView1okahhU0v0Meta?.alias || [],
    redirect: examView1okahhU0v0Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/examView.vue").then(m => m.default || m)
  },
  {
    name: indexeeGSfJiJUOMeta?.name ?? "onlineExam",
    path: indexeeGSfJiJUOMeta?.path ?? "/onlineExam",
    meta: indexeeGSfJiJUOMeta || {},
    alias: indexeeGSfJiJUOMeta?.alias || [],
    redirect: indexeeGSfJiJUOMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/index.vue").then(m => m.default || m)
  },
  {
    name: problemItemr2HT2l2EqhMeta?.name ?? "onlineExam-problemItem",
    path: problemItemr2HT2l2EqhMeta?.path ?? "/onlineExam/problemItem",
    meta: problemItemr2HT2l2EqhMeta || {},
    alias: problemItemr2HT2l2EqhMeta?.alias || [],
    redirect: problemItemr2HT2l2EqhMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/problemItem.vue").then(m => m.default || m)
  },
  {
    name: resultMbR7nCF5uDMeta?.name ?? "onlineExam-result",
    path: resultMbR7nCF5uDMeta?.path ?? "/onlineExam/result",
    meta: resultMbR7nCF5uDMeta || {},
    alias: resultMbR7nCF5uDMeta?.alias || [],
    redirect: resultMbR7nCF5uDMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/result.vue").then(m => m.default || m)
  },
  {
    name: signqhoUJwmCaMMeta?.name ?? "onlineExam-sign",
    path: signqhoUJwmCaMMeta?.path ?? "/onlineExam/sign",
    meta: signqhoUJwmCaMMeta || {},
    alias: signqhoUJwmCaMMeta?.alias || [],
    redirect: signqhoUJwmCaMMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/sign.vue").then(m => m.default || m)
  },
  {
    name: startExam0dFc2mBCMyMeta?.name ?? "onlineExam-startExam",
    path: startExam0dFc2mBCMyMeta?.path ?? "/onlineExam/startExam",
    meta: startExam0dFc2mBCMyMeta || {},
    alias: startExam0dFc2mBCMyMeta?.alias || [],
    redirect: startExam0dFc2mBCMyMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/onlineExam/startExam.vue").then(m => m.default || m)
  },
  {
    name: childrenListbk0VRspvSQMeta?.name ?? "paper-childrenList",
    path: childrenListbk0VRspvSQMeta?.path ?? "/paper/childrenList",
    meta: childrenListbk0VRspvSQMeta || {},
    alias: childrenListbk0VRspvSQMeta?.alias || [],
    redirect: childrenListbk0VRspvSQMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/paper/childrenList.vue").then(m => m.default || m)
  },
  {
    name: emigrated9LBXnPIDxJMeta?.name ?? "paper-emigrated",
    path: emigrated9LBXnPIDxJMeta?.path ?? "/paper/emigrated",
    meta: emigrated9LBXnPIDxJMeta || {},
    alias: emigrated9LBXnPIDxJMeta?.alias || [],
    redirect: emigrated9LBXnPIDxJMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/paper/emigrated.vue").then(m => m.default || m)
  },
  {
    name: indexyAurNVIhdVMeta?.name ?? "paper",
    path: indexyAurNVIhdVMeta?.path ?? "/paper",
    meta: indexyAurNVIhdVMeta || {},
    alias: indexyAurNVIhdVMeta?.alias || [],
    redirect: indexyAurNVIhdVMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/paper/index.vue").then(m => m.default || m)
  },
  {
    name: list4zMKeIEgDIMeta?.name ?? "paper-list",
    path: list4zMKeIEgDIMeta?.path ?? "/paper/list",
    meta: list4zMKeIEgDIMeta || {},
    alias: list4zMKeIEgDIMeta?.alias || [],
    redirect: list4zMKeIEgDIMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/paper/list.vue").then(m => m.default || m)
  },
  {
    name: viewW1gLYRFBV2Meta?.name ?? "paper-view",
    path: viewW1gLYRFBV2Meta?.path ?? "/paper/view",
    meta: viewW1gLYRFBV2Meta || {},
    alias: viewW1gLYRFBV2Meta?.alias || [],
    redirect: viewW1gLYRFBV2Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/paper/view.vue").then(m => m.default || m)
  },
  {
    name: contentN2jev2QGSJMeta?.name ?? "partys-content",
    path: contentN2jev2QGSJMeta?.path ?? "/partys/content",
    meta: contentN2jev2QGSJMeta || {},
    alias: contentN2jev2QGSJMeta?.alias || [],
    redirect: contentN2jev2QGSJMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/partys/content.vue").then(m => m.default || m)
  },
  {
    name: indexeV0WS1joemMeta?.name ?? "partys",
    path: indexeV0WS1joemMeta?.path ?? "/partys",
    meta: indexeV0WS1joemMeta || {},
    alias: indexeV0WS1joemMeta?.alias || [],
    redirect: indexeV0WS1joemMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/partys/index.vue").then(m => m.default || m)
  },
  {
    name: buyjaPX6TlZucMeta?.name ?? "pay-buy",
    path: buyjaPX6TlZucMeta?.path ?? "/pay/buy",
    meta: buyjaPX6TlZucMeta || {},
    alias: buyjaPX6TlZucMeta?.alias || [],
    redirect: buyjaPX6TlZucMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/pay/buy.vue").then(m => m.default || m)
  },
  {
    name: paySuccessQPUdUn2DHvMeta?.name ?? "pay-paySuccess",
    path: paySuccessQPUdUn2DHvMeta?.path ?? "/pay/paySuccess",
    meta: paySuccessQPUdUn2DHvMeta || {},
    alias: paySuccessQPUdUn2DHvMeta?.alias || [],
    redirect: paySuccessQPUdUn2DHvMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/pay/paySuccess.vue").then(m => m.default || m)
  },
  {
    name: analysisc0YOtZdnf6Meta?.name ?? "practice-analysis",
    path: analysisc0YOtZdnf6Meta?.path ?? "/practice/analysis",
    meta: analysisc0YOtZdnf6Meta || {},
    alias: analysisc0YOtZdnf6Meta?.alias || [],
    redirect: analysisc0YOtZdnf6Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/analysis.vue").then(m => m.default || m)
  },
  {
    name: dailypn6AOjS2u2Meta?.name ?? "practice-daily",
    path: dailypn6AOjS2u2Meta?.path ?? "/practice/daily",
    meta: dailypn6AOjS2u2Meta || {},
    alias: dailypn6AOjS2u2Meta?.alias || [],
    redirect: dailypn6AOjS2u2Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/daily.vue").then(m => m.default || m)
  },
  {
    name: dailyProblem9NCNB5NOM1Meta?.name ?? "practice-dailyProblem",
    path: dailyProblem9NCNB5NOM1Meta?.path ?? "/practice/dailyProblem",
    meta: dailyProblem9NCNB5NOM1Meta || {},
    alias: dailyProblem9NCNB5NOM1Meta?.alias || [],
    redirect: dailyProblem9NCNB5NOM1Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/dailyProblem.vue").then(m => m.default || m)
  },
  {
    name: errorpH0uNkDhKpMeta?.name ?? "practice-error",
    path: errorpH0uNkDhKpMeta?.path ?? "/practice/error",
    meta: errorpH0uNkDhKpMeta || {},
    alias: errorpH0uNkDhKpMeta?.alias || [],
    redirect: errorpH0uNkDhKpMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/error.vue").then(m => m.default || m)
  },
  {
    name: errorAnalysisaqapHIiB7YMeta?.name ?? "practice-errorAnalysis",
    path: errorAnalysisaqapHIiB7YMeta?.path ?? "/practice/errorAnalysis",
    meta: errorAnalysisaqapHIiB7YMeta || {},
    alias: errorAnalysisaqapHIiB7YMeta?.alias || [],
    redirect: errorAnalysisaqapHIiB7YMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/errorAnalysis.vue").then(m => m.default || m)
  },
  {
    name: errorProblemsjccXApWIOMeta?.name ?? "practice-errorProblem",
    path: errorProblemsjccXApWIOMeta?.path ?? "/practice/errorProblem",
    meta: errorProblemsjccXApWIOMeta || {},
    alias: errorProblemsjccXApWIOMeta?.alias || [],
    redirect: errorProblemsjccXApWIOMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/errorProblem.vue").then(m => m.default || m)
  },
  {
    name: errorResultqlFctGtklOMeta?.name ?? "practice-errorResult",
    path: errorResultqlFctGtklOMeta?.path ?? "/practice/errorResult",
    meta: errorResultqlFctGtklOMeta || {},
    alias: errorResultqlFctGtklOMeta?.alias || [],
    redirect: errorResultqlFctGtklOMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/errorResult.vue").then(m => m.default || m)
  },
  {
    name: resultMvIEfkSwL5Meta?.name ?? "practice-result",
    path: resultMvIEfkSwL5Meta?.path ?? "/practice/result",
    meta: resultMvIEfkSwL5Meta || {},
    alias: resultMvIEfkSwL5Meta?.alias || [],
    redirect: resultMvIEfkSwL5Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/result.vue").then(m => m.default || m)
  },
  {
    name: startPracticeHuGdzBQeyjMeta?.name ?? "practice-startPractice",
    path: startPracticeHuGdzBQeyjMeta?.path ?? "/practice/startPractice",
    meta: startPracticeHuGdzBQeyjMeta || {},
    alias: startPracticeHuGdzBQeyjMeta?.alias || [],
    redirect: startPracticeHuGdzBQeyjMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/startPractice.vue").then(m => m.default || m)
  },
  {
    name: view20znInTZP2Meta?.name ?? "practice-view",
    path: view20znInTZP2Meta?.path ?? "/practice/view",
    meta: view20znInTZP2Meta || {},
    alias: view20znInTZP2Meta?.alias || [],
    redirect: view20znInTZP2Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/practice/view.vue").then(m => m.default || m)
  },
  {
    name: indexgTrHaOOix3Meta?.name ?? "register",
    path: indexgTrHaOOix3Meta?.path ?? "/register",
    meta: indexgTrHaOOix3Meta || {},
    alias: indexgTrHaOOix3Meta?.alias || [],
    redirect: indexgTrHaOOix3Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/register/index.vue").then(m => m.default || m)
  },
  {
    name: indext7ZFNXG5Z4Meta?.name ?? "resetpwd",
    path: indext7ZFNXG5Z4Meta?.path ?? "/resetpwd",
    meta: indext7ZFNXG5Z4Meta || {},
    alias: indext7ZFNXG5Z4Meta?.alias || [],
    redirect: indext7ZFNXG5Z4Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/resetpwd/index.vue").then(m => m.default || m)
  },
  {
    name: indexcW2X1dCfnkMeta?.name ?? "search",
    path: indexcW2X1dCfnkMeta?.path ?? "/search",
    meta: indexcW2X1dCfnkMeta || {},
    alias: indexcW2X1dCfnkMeta?.alias || [],
    redirect: indexcW2X1dCfnkMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexblTPJVItxHMeta?.name ?? "settlement",
    path: indexblTPJVItxHMeta?.path ?? "/settlement",
    meta: indexblTPJVItxHMeta || {},
    alias: indexblTPJVItxHMeta?.alias || [],
    redirect: indexblTPJVItxHMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/settlement/index.vue").then(m => m.default || m)
  },
  {
    name: list5IDc91Yy58Meta?.name ?? "teacher-list",
    path: list5IDc91Yy58Meta?.path ?? "/teacher/list",
    meta: list5IDc91Yy58Meta || {},
    alias: list5IDc91Yy58Meta?.alias || [],
    redirect: list5IDc91Yy58Meta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/teacher/list.vue").then(m => m.default || m)
  },
  {
    name: viewy48elAjkpNMeta?.name ?? "teacher-view",
    path: viewy48elAjkpNMeta?.path ?? "/teacher/view",
    meta: viewy48elAjkpNMeta || {},
    alias: viewy48elAjkpNMeta?.alias || [],
    redirect: viewy48elAjkpNMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/teacher/view.vue").then(m => m.default || m)
  },
  {
    name: indexbE5hZNfXwaMeta?.name ?? "vip",
    path: indexbE5hZNfXwaMeta?.path ?? "/vip",
    meta: indexbE5hZNfXwaMeta || {},
    alias: indexbE5hZNfXwaMeta?.alias || [],
    redirect: indexbE5hZNfXwaMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/vip/index.vue").then(m => m.default || m)
  },
  {
    name: success0vsJ8tnXivMeta?.name ?? "wx-success",
    path: success0vsJ8tnXivMeta?.path ?? "/wx/success",
    meta: success0vsJ8tnXivMeta || {},
    alias: success0vsJ8tnXivMeta?.alias || [],
    redirect: success0vsJ8tnXivMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/wx/success.vue").then(m => m.default || m)
  },
  {
    name: wxaMcj8zRa0CMeta?.name ?? "wx-wx",
    path: wxaMcj8zRa0CMeta?.path ?? "/wx/wx",
    meta: wxaMcj8zRa0CMeta || {},
    alias: wxaMcj8zRa0CMeta?.alias || [],
    redirect: wxaMcj8zRa0CMeta?.redirect || undefined,
    component: () => import("E:/workspace/roncoo/roncoo-web/pages/wx/wx.vue").then(m => m.default || m)
  }
]